"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbProvider = exports.BreadcrumbSeparator = exports.BreadcrumbPage = exports.BreadcrumbLink = exports.BreadcrumbItem = exports.BreadcrumbList = exports.Breadcrumb = void 0;
const react_1 = __importStar(require("react"));
const link_1 = __importDefault(require("next/link"));
const BreadcrumbContext = (0, react_1.createContext)(undefined);
const Breadcrumb = ({ children, className = "" }) => (react_1.default.createElement("nav", { "aria-label": "Breadcrumb", className: className }, children));
exports.Breadcrumb = Breadcrumb;
const BreadcrumbList = ({ children, className = "" }) => (react_1.default.createElement("ol", { className: `flex items-center [&>span]:text-[14px] ${className}` }, children));
exports.BreadcrumbList = BreadcrumbList;
const BreadcrumbItem = ({ children, className = "" }) => (react_1.default.createElement("li", { className: `flex items-center [&>a]:underline [&>a]:text-brandBlack  [&>span]:text-brandBlack [&>a]:text-[14px] [&>span]:text-[14px] ${className}` }, children));
exports.BreadcrumbItem = BreadcrumbItem;
const BreadcrumbLink = ({ href, children, className = "", ariaLabel = "", }) => (react_1.default.createElement(link_1.default, { href: href, className: `text-blue-600 hover:underline ${className}`, "aria-label": ariaLabel }, children));
exports.BreadcrumbLink = BreadcrumbLink;
const BreadcrumbPage = ({ children, className = "" }) => (react_1.default.createElement("span", { className: `font-semibold ${className}`, "aria-current": "page" }, children));
exports.BreadcrumbPage = BreadcrumbPage;
const BreadcrumbSeparator = ({ className = "" }) => {
    const context = (0, react_1.useContext)(BreadcrumbContext);
    if (!context) {
        throw new Error("BreadcrumbSeparator must be used within a BreadcrumbProvider");
    }
    return react_1.default.createElement("span", { className: `mx-1 text-brandBlack font-normal ${className}` }, context.separator);
};
exports.BreadcrumbSeparator = BreadcrumbSeparator;
const BreadcrumbProvider = ({ children, separator = "/", }) => (react_1.default.createElement(BreadcrumbContext.Provider, { value: { separator } }, children));
exports.BreadcrumbProvider = BreadcrumbProvider;
